"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN ManualTask.
 *
 * Currently not evaluated during runtime.
 */
class ManualTask extends ActivityBase_1.Activity {
    constructor() {
        super(...arguments);
        this.requiresConfirmation = true;
    }
    get bpmnType() {
        return Constants_1.BpmnType.manualTask;
    }
}
exports.ManualTask = ManualTask;
//# sourceMappingURL=ManualTask.js.map